import { render, staticRenderFns } from "./UsuarioFuncionarioTabela.vue?vue&type=template&id=dea92244&lang=html"
import script from "./UsuarioFuncionarioTabela.vue?vue&type=script&lang=js"
export * from "./UsuarioFuncionarioTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports